import { createSlice,  PayloadAction } from "@reduxjs/toolkit";
import {

  Unsubscribe,
  Timestamp,
} from "firebase/firestore";
import { RootState } from "../store/store";

// Define subscription type
interface SubscriptionData {
  id: string;
  company_id: string;
  status: string;
  plan_id?: string;
  plan_name?: string;
  created_at?: Timestamp;
  subscription_start_date?: Timestamp | null;
  subscription_end_date?: Timestamp | null;
  allowed_staff_limit: number;
  allowed_branch_limit: number;
  // allowed_staff_limit?: number;
  remaining_staff_limit: number;
  remaining_branch_limit: number;
  // remining_staff_limit?: number;
  features?:any// ✅ FIXED: Change to an object

}

interface SubscriptionState {
  active: boolean | null;
  snapshot: SubscriptionData[];
  loading: boolean;
  error: string | null;
  unsubscribe: Unsubscribe | null;
}

// Initial state
const initialState: SubscriptionState = {
  active: null,
  snapshot: [],
  loading: true,
  error: null,
  unsubscribe: null,
};

// Redux slice
const subscriptionSlice = createSlice({
  name: "subscription",
  initialState,
  reducers: {
    setSubscription: (
      state,
      action: PayloadAction<{ active: boolean; snapshot: SubscriptionData[] }>
    ) => {
      state.active = action.payload.active;
      state.snapshot = action.payload.snapshot;
      state.loading = false;
    },
    setUnsubscribe: (state, action: PayloadAction<Unsubscribe | null>) => {
      if (state.unsubscribe) {
        state.unsubscribe(); // Unsubscribe previous listener before assigning a new one
      }
      state.unsubscribe = action.payload;
    },
    clearSubscription: (state) => {
      if (state.unsubscribe) {
        state.unsubscribe();
      }
      state.active = null;
      state.snapshot = [];
      state.loading = true;
      state.error = null;
      state.unsubscribe = null;
    },
  },
});

export const { setSubscription, setUnsubscribe, clearSubscription } =
  subscriptionSlice.actions;

// Selector
export const selectSubscriptionStatus = (state: RootState) => state.subscriptionData;

// Reducer export
export default subscriptionSlice.reducer;
